import React, { useState, useRef } from "react";
import { Footer } from '../../components/footer/Footer';
const personaQuizPic = '/org/gds/GDS-Brand-Logo-518-2025.png';
import './PersonaQuizPage.scss';

interface Question {
  question: string;
  response: number | null;
}

interface QuizData {
  questions: Record<string, Question>; // ✅ Explicitly allow dynamic key indexing
}

function PersonaQuizPage() {
  const [errorMessage, setErrorMessage] = useState("");
  const containerRef = useRef<HTMLDivElement>(null);

  // ✅ Explicitly type state to ensure TypeScript recognizes keys correctly
  const [quizData, setQuizData] = useState<QuizData>({
    questions: {
      "1": { question: "I often have big ideas and dreams about what I want to achieve in the future.", response: null },
      "2": { question: "I am motivated to compete and strive for top performance in my work.", response: null },
      "3": { question: "I enjoy meeting new people and creating connections in my professional life.", response: null },
      "4": { question: "I spend time reflecting on my experiences and seeking ways to improve.", response: null },
      "5": { question: "I prefer to create detailed plans and strategies before taking action.", response: null },
      "6": { question: "I find storytelling to be an effective way of communicating my ideas to others.", response: null },
      "7": { question: "I am often inspired by the possibility of creating something new and impactful.", response: null },
      "8": { question: "I enjoy taking on challenges that push my limits.", response: null },
      "9": { question: "Building and maintaining relationships is important to me in my work life.", response: null },
      "10": { question: "I regularly assess my performance and seek feedback to grow.", response: null },
      "11": { question: "I feel comfortable engaging in detailed analysis to solve problems.", response: null },
      "12": { question: "I believe in the power of narratives to influence and inspire others.", response: null }
    }
  });

  // ✅ Fix: Convert `id` to string before accessing `questions`
  const handleResponseChange = (id: number, value: number) => {
    const key = id.toString(); // ✅ Convert number to string

    setQuizData(prevData => ({
      ...prevData,
      questions: {
        ...prevData.questions,
        [key]: {  // ✅ TypeScript now correctly recognizes `questions[key]`
          ...prevData.questions[key],
          response: value
        }
      }
    }));
  };

  // Handle form submission
  const handlePersonaQuizPage = (event: React.FormEvent) => {
    event.preventDefault();

    const hideErr = document.getElementById("errorStatus");
    if (hideErr) {
        hideErr.style.display = "none"; // Corrected from "n" to "none"
    }

    // Check if all questions have been answered
    const unanswered = Object.values(quizData.questions).some(q => q.response === null);
    if (unanswered) {
      setErrorMessage("Please answer all questions before submitting.");
      return;
    }

    console.log("User Responses:", JSON.stringify(quizData, null, 2)); // ✅ Added console log to show selections clearly

    alert("Account Created! Please look for authorization Email to continue");
  
    window.location.href = "/signin"
    
  };

  return (
    <div id="pageContainer" className="pageContainer" ref={containerRef}>
        <style>{`
          /*
            Same class-name mismatch bug as PreferencesPage/OrientationPage: this page's
            PersonaQuizPage.scss styles .personaQuizPageContainer (JSX uses .pageContainer)
            and .personaQuizPic (JSX uses .preferencesPic on the logo), and its responsive
            blocks target .personaQuiz-container (JSX has no hyphen) - none of it matched.
            The inner quiz wrapper also reused the outer container's exact class name
            (.personaQuizContainer), so any fix targeting that class would have hit both -
            renamed the inner one to .personaQuizFormContainer below. Aligned to the same
            palette/layout as SignUpPage.tsx, PreferencesPage.tsx and OrientationPage.tsx.
          */
          body, html, #root {
            background-color: #551540 !important;
          }
          #pageContainer, .pageContainer {
            display: flex !important;
            flex-direction: column !important;
            align-items: center !important;
            width: 100% !important;
            min-height: 100vh !important;
            height: auto !important;
            background-color: #551540 !important;
            color: #F3F1E8 !important;
            padding: 24px 16px 64px !important;
            box-sizing: border-box !important;
            overflow-x: hidden !important;
          }
          #pageContainer * {
            box-sizing: border-box;
          }
          #personaQuizContainer, .personaQuizContainer {
            display: flex !important;
            flex-direction: column !important;
            align-items: center !important;
            width: 100% !important;
            max-width: 720px !important;
            margin: 0 auto !important;
            gap: 0 !important;
          }
          .pageImageContainer, #pageImageContainer {
            width: 100% !important;
            display: flex !important;
            justify-content: center !important;
            align-items: center !important;
            margin: 0 auto 12px !important;
          }
          .preferencesPic, #preferencesPic {
            width: 90px !important;
            max-width: 90px !important;
            height: auto !important;
            margin: 0 auto !important;
            display: block !important;
          }
          .personaQuizTitle {
            text-align: center !important;
            width: 100% !important;
            margin: 0 auto 14px !important;
            color: #F3F1E8 !important;
            font-size: 1.3rem !important;
            font-weight: 600 !important;
          }
          .personaQuiz-card {
            width: 100% !important;
            margin: 0 auto 16px !important;
          }
          .personaQuizSubTitle {
            margin: 0 0 8px !important;
          }
          .personaQuizDescriptionText {
            margin: 0 !important;
            color: #222 !important;
            font-size: 0.9rem !important;
            line-height: 1.4 !important;
          }
          .horiz-rule {
            max-width: 100% !important;
          }
          .personaQuizFormContainer {
            width: 100% !important;
            background: #fff !important;
            color: #222 !important;
            border-radius: 1.5rem !important;
            padding: 1.5rem !important;
            margin: 0 0 16px !important;
            box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1) !important;
            box-sizing: border-box !important;
          }
          .question {
            text-align: left !important;
            padding: 10px 0 !important;
            border-bottom: 1px solid #eee !important;
          }
          .question:last-of-type {
            border-bottom: none !important;
          }
          .question p {
            margin: 0 0 8px !important;
            font-weight: 500 !important;
          }
          .options {
            display: flex !important;
            flex-wrap: wrap !important;
            gap: 16px !important;
          }
          .options label {
            display: flex !important;
            align-items: center !important;
            gap: 4px !important;
            cursor: pointer !important;
          }
          .personaQuizButtonContainer {
            display: flex !important;
            flex-wrap: wrap !important;
            justify-content: center !important;
            gap: 12px !important;
            width: 100% !important;
            max-width: 300px !important;
            margin: 12px auto 0 !important;
          }
          .signUpButton, .signInButton {
            flex: 1 1 130px !important;
            max-width: 190px !important;
            padding: 10px 18px !important;
            border: none !important;
            border-radius: 24px !important;
            font-weight: 600 !important;
            cursor: pointer !important;
          }
          .signUpColor {
            background-color: #551540 !important;
            color: #F3F1E8 !important;
          }
          @media (max-width: 480px) {
            .preferencesPic, #preferencesPic {
              width: 70px !important;
              max-width: 70px !important;
            }
            .personaQuizButtonContainer {
              flex-direction: column !important;
              align-items: stretch !important;
              max-width: 100% !important;
            }
          }
        `}</style>
      <div id="personaQuizContainer" className="personaQuizContainer">

        {/* Logo: fixed at top, centered - matches SignUpPage/PreferencesPage/OrientationPage */}
        <div id="pageImageContainer" className="pageImageContainer">
            <img
            id="preferencesPic"
            className="preferencesPic"
            src={personaQuizPic}
            alt="Company Logo"
            />
        </div>

        <div className="personaQuizTitle"> Coach Yourself To Win - Persona Quiz</div>

        <div className="personaQuiz-card">
            <div className="headerContainer">
            <h2 className='personaQuizSubTitle'>Self-Determination Questionnaire</h2>

            <div className="personaQuizDescription">
                <div className="personaQuizDescriptionText">
                    <p>This is a preliminary High-Performance survey to help us get started.
                    We will create a cirriculum for you based on your replies, which you may change later.
                    For each question, you can rate yourself on a scale from 1 to 5, where 1 means "Strongly Disagree" and 5 means "Strongly Agree."</p>
                </div>
                <hr className="horiz-rule"></hr>
            </div>
            </div>
        </div>

        {/* Quiz */}
        <div className="personaQuizFormContainer">
          <form onSubmit={handlePersonaQuizPage} className="persona-quiz">
            {Object.entries(quizData.questions).map(([id, item]) => (
              <div key={id} className="question">
                <p>{id}. {item.question}</p>
                <div className="options">
                  {[1, 2, 3, 4, 5].map(num => (
                    <label key={num}>
                      <input
                        type="radio"
                        name={`q${id}`}
                        value={num}
                        checked={item.response === num}
                        onChange={() => handleResponseChange(parseInt(id), num)} // ✅ Convert back to number
                        required
                      /> {num}
                    </label>
                  ))}
                </div>
              </div>
            ))}
          </form>
        </div>

        {/* Error Message Display */}
        {errorMessage && <div className="errorStatus" style={{width:"100%"}}>{errorMessage}</div>}

        {/* Buttons */}
        <div className="personaQuizButtonContainer">
            <button
              className="signUpButton signUpColor"
              type="button"
              onClick={() => {
                if (window.history.length > 1) {
                  window.history.back();
                } else {
                  // Opened directly, nothing to go back to: go to sign-in and keep the agent (?id=)
                  window.location.href = `/signin${window.location.search}`;
                }
              }}
            >
              Go Back
            </button>

          <button
            id="personaQuizButton"
            className="signInButton signUpColor"
            type="submit"
            onClick={(e) => handlePersonaQuizPage(e)}
          >Submit</button>
        </div>

      </div>
    <Footer />
    </div>
  );
}

export default PersonaQuizPage;
